module.exports = __webpack_public_path__ + "static/media/barchart.cdb9faec.svg";